// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"84912782","104":"1e15dc39","265":"6859a45d","351":"b5b5172c","419":"c4225909","591":"12b4c899","665":"f6e8f474","708":"16612876","756":"a478c5e9","828":"f5c459fd","908":"127674d2","985":"e35eac8d"}[chunkId] + ".chunk.js";
};